/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@frete.com/fuel-components/loader';
defineCustomElements();
export const FuelAccordionContainer = /*@__PURE__*/ createReactComponent('fuel-accordion-container');
export const FuelAccordionItem = /*@__PURE__*/ createReactComponent('fuel-accordion-item');
export const FuelAvatar = /*@__PURE__*/ createReactComponent('fuel-avatar');
export const FuelBackdrop = /*@__PURE__*/ createReactComponent('fuel-backdrop');
export const FuelBadge = /*@__PURE__*/ createReactComponent('fuel-badge');
export const FuelBullet = /*@__PURE__*/ createReactComponent('fuel-bullet');
export const FuelButton = /*@__PURE__*/ createReactComponent('fuel-button');
export const FuelCallout = /*@__PURE__*/ createReactComponent('fuel-callout');
export const FuelCard = /*@__PURE__*/ createReactComponent('fuel-card');
export const FuelCheckbox = /*@__PURE__*/ createReactComponent('fuel-checkbox');
export const FuelChip = /*@__PURE__*/ createReactComponent('fuel-chip');
export const FuelDatePicker = /*@__PURE__*/ createReactComponent('fuel-date-picker');
export const FuelDivider = /*@__PURE__*/ createReactComponent('fuel-divider');
export const FuelDropdown = /*@__PURE__*/ createReactComponent('fuel-dropdown');
export const FuelFilter = /*@__PURE__*/ createReactComponent('fuel-filter');
export const FuelGridContainer = /*@__PURE__*/ createReactComponent('fuel-grid-container');
export const FuelGridItem = /*@__PURE__*/ createReactComponent('fuel-grid-item');
export const FuelIcon = /*@__PURE__*/ createReactComponent('fuel-icon');
export const FuelIllustration = /*@__PURE__*/ createReactComponent('fuel-illustration');
export const FuelInteractiveIcon = /*@__PURE__*/ createReactComponent('fuel-interactive-icon');
export const FuelLink = /*@__PURE__*/ createReactComponent('fuel-link');
export const FuelLoading = /*@__PURE__*/ createReactComponent('fuel-loading');
export const FuelProgressBar = /*@__PURE__*/ createReactComponent('fuel-progress-bar');
export const FuelRadio = /*@__PURE__*/ createReactComponent('fuel-radio');
export const FuelRating = /*@__PURE__*/ createReactComponent('fuel-rating');
export const FuelReload = /*@__PURE__*/ createReactComponent('fuel-reload');
export const FuelSearchbox = /*@__PURE__*/ createReactComponent('fuel-searchbox');
export const FuelSelect = /*@__PURE__*/ createReactComponent('fuel-select');
export const FuelSign = /*@__PURE__*/ createReactComponent('fuel-sign');
export const FuelSkeleton = /*@__PURE__*/ createReactComponent('fuel-skeleton');
export const FuelSlider = /*@__PURE__*/ createReactComponent('fuel-slider');
export const FuelSwitch = /*@__PURE__*/ createReactComponent('fuel-switch');
export const FuelTab = /*@__PURE__*/ createReactComponent('fuel-tab');
export const FuelTabContent = /*@__PURE__*/ createReactComponent('fuel-tab-content');
export const FuelTabItem = /*@__PURE__*/ createReactComponent('fuel-tab-item');
export const FuelTable = /*@__PURE__*/ createReactComponent('fuel-table');
export const FuelTag = /*@__PURE__*/ createReactComponent('fuel-tag');
export const FuelTextArea = /*@__PURE__*/ createReactComponent('fuel-text-area');
export const FuelTextField = /*@__PURE__*/ createReactComponent('fuel-text-field');
export const FuelTfooter = /*@__PURE__*/ createReactComponent('fuel-tfooter');
export const FuelThead = /*@__PURE__*/ createReactComponent('fuel-thead');
export const FuelTheadItem = /*@__PURE__*/ createReactComponent('fuel-thead-item');
export const FuelToast = /*@__PURE__*/ createReactComponent('fuel-toast');
export const FuelTooltip = /*@__PURE__*/ createReactComponent('fuel-tooltip');
export const FuelTrackingContainer = /*@__PURE__*/ createReactComponent('fuel-tracking-container');
export const FuelTrackingItem = /*@__PURE__*/ createReactComponent('fuel-tracking-item');
export const FuelTrow = /*@__PURE__*/ createReactComponent('fuel-trow');
export const FuelTrowItem = /*@__PURE__*/ createReactComponent('fuel-trow-item');
export const FuelTypography = /*@__PURE__*/ createReactComponent('fuel-typography');
//# sourceMappingURL=index.js.map